const buildVariantLabel = (item = {}) => {
  const ram = item.ram ?? item.memory;
  const storage = item.storage ?? item.storage_gb;
  if (ram && storage) return `${ram}/${storage}`;
  if (storage) return String(storage).includes("GB") ? storage : `${storage}GB`;
  return item.variant ?? item.variant_name ?? "";
};

const getIndexValue = (item = {}, fallbackIndex = 0) => {
  const raw =
    item.index ??
    item.indexing ??
    item.order ??
    item.position ??
    item.sort_order;
  return raw != null ? String(raw) : String(fallbackIndex + 1);
};

const sortByIndexValue = (list = []) =>
  [...list].sort((a, b) => Number(a.index) - Number(b.index));

export const normalizeCatalogProduct = (item = {}, index = 0) => {
  const rowId =
    item.id ??
    item.price_list_product_id ??
    item.catalog_product_id ??
    `product-${index}`;

  return {
    id: rowId,
    productId: item.product_id ?? item.product ?? item.product_id_id ?? rowId,
    index: getIndexValue(item, index),
    name: item.name ?? item.product_name ?? item.product ?? "",
    variant: buildVariantLabel(item),
    price:
      item.price ??
      item.selling_price ??
      item.catalog_price ??
      item.list_price ??
      item.amount ??
      null,
  };
};

export const normalizeCatalogGroup = (apiGroup = {}, index = 0) => {
  const productsSource =
    apiGroup.products ??
    apiGroup.price_list_products ??
    apiGroup.catalog_products ??
    apiGroup.items ??
    apiGroup.product_list ??
    apiGroup.lines ??
    [];

  const rawIndex =
    apiGroup.index ?? apiGroup.indexing ?? apiGroup.order ?? apiGroup.position;

  return {
    id: apiGroup.id ?? apiGroup.group_id ?? apiGroup.price_list_id,
    index: rawIndex != null ? String(rawIndex) : String(index + 1),
    themeKey: apiGroup.theme_key ?? apiGroup.themeKey ?? apiGroup.theme,
    name:
      apiGroup.name ??
      apiGroup.group_name ??
      apiGroup.price_list_name ??
      apiGroup.title ??
      "",
    currencySymbol:
      apiGroup.currency_symbol ?? apiGroup.currencySymbol ?? apiGroup.currency ?? "€",
    products: sortByIndexValue(productsSource.map(normalizeCatalogProduct)),
  };
};

export const normalizeCatalogGroups = (apiGroups = []) =>
  apiGroups.map((group, index) => normalizeCatalogGroup(group, index));
